import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isCloudflareWorkers } from './env.js';
import crypto from './webcrypto.js';
import { JOSENotSupported } from '../util/errors.js';
import random from './random.js';
export function generateSecret(_x, _x2) {
  return _generateSecret.apply(this, arguments);
}

function _generateSecret() {
  _generateSecret = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, options) {
    var _a, length, algorithm, keyUsages;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = alg;
            _context.next = _context.t0 === 'HS256' ? 3 : _context.t0 === 'HS384' ? 3 : _context.t0 === 'HS512' ? 3 : _context.t0 === 'A128CBC-HS256' ? 7 : _context.t0 === 'A192CBC-HS384' ? 7 : _context.t0 === 'A256CBC-HS512' ? 7 : _context.t0 === 'A128KW' ? 9 : _context.t0 === 'A192KW' ? 9 : _context.t0 === 'A256KW' ? 9 : _context.t0 === 'A128GCMKW' ? 13 : _context.t0 === 'A192GCMKW' ? 13 : _context.t0 === 'A256GCMKW' ? 13 : _context.t0 === 'A128GCM' ? 13 : _context.t0 === 'A192GCM' ? 13 : _context.t0 === 'A256GCM' ? 13 : 17;
            break;

          case 3:
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
              name: 'HMAC',
              hash: "SHA-".concat(length),
              length: length
            };
            keyUsages = ['sign', 'verify'];
            return _context.abrupt("break", 18);

          case 7:
            length = parseInt(alg.slice(-3), 10);
            return _context.abrupt("return", random(new Uint8Array(length >> 3)));

          case 9:
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
              name: 'AES-KW',
              length: length
            };
            keyUsages = ['wrapKey', 'unwrapKey'];
            return _context.abrupt("break", 18);

          case 13:
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
              name: 'AES-GCM',
              length: length
            };
            keyUsages = ['encrypt', 'decrypt'];
            return _context.abrupt("break", 18);

          case 17:
            throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');

          case 18:
            return _context.abrupt("return", crypto.subtle.generateKey(algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _generateSecret.apply(this, arguments);
}

function getModulusLengthOption(options) {
  var _a;

  var modulusLength = (_a = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _a !== void 0 ? _a : 2048;

  if (typeof modulusLength !== 'number' || modulusLength < 2048) {
    throw new JOSENotSupported('Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used');
  }

  return modulusLength;
}

export function generateKeyPair(_x3, _x4) {
  return _generateKeyPair.apply(this, arguments);
}

function _generateKeyPair() {
  _generateKeyPair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(alg, options) {
    var _a, _b, _c, algorithm, keyUsages, crv, _crv;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = alg;
            _context2.next = _context2.t0 === 'PS256' ? 3 : _context2.t0 === 'PS384' ? 3 : _context2.t0 === 'PS512' ? 3 : _context2.t0 === 'RS256' ? 6 : _context2.t0 === 'RS384' ? 6 : _context2.t0 === 'RS512' ? 6 : _context2.t0 === 'RSA-OAEP' ? 9 : _context2.t0 === 'RSA-OAEP-256' ? 9 : _context2.t0 === 'RSA-OAEP-384' ? 9 : _context2.t0 === 'RSA-OAEP-512' ? 9 : _context2.t0 === 'ES256' ? 12 : _context2.t0 === 'ES384' ? 15 : _context2.t0 === 'ES512' ? 18 : _context2.t0 === (isCloudflareWorkers() && 'EdDSA') ? 21 : _context2.t0 === 'EdDSA' ? 29 : _context2.t0 === 'ECDH-ES' ? 38 : _context2.t0 === 'ECDH-ES+A128KW' ? 38 : _context2.t0 === 'ECDH-ES+A192KW' ? 38 : _context2.t0 === 'ECDH-ES+A256KW' ? 38 : 49;
            break;

          case 3:
            algorithm = {
              name: 'RSA-PSS',
              hash: "SHA-".concat(alg.slice(-3)),
              publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
              modulusLength: getModulusLengthOption(options)
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 50);

          case 6:
            algorithm = {
              name: 'RSASSA-PKCS1-v1_5',
              hash: "SHA-".concat(alg.slice(-3)),
              publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
              modulusLength: getModulusLengthOption(options)
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 50);

          case 9:
            algorithm = {
              name: 'RSA-OAEP',
              hash: "SHA-".concat(parseInt(alg.slice(-3), 10) || 1),
              publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
              modulusLength: getModulusLengthOption(options)
            };
            keyUsages = ['decrypt', 'unwrapKey', 'encrypt', 'wrapKey'];
            return _context2.abrupt("break", 50);

          case 12:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-256'
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 50);

          case 15:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-384'
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 50);

          case 18:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-521'
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 50);

          case 21:
            _context2.t1 = options === null || options === void 0 ? void 0 : options.crv;
            _context2.next = _context2.t1 === undefined ? 24 : _context2.t1 === 'Ed25519' ? 24 : 27;
            break;

          case 24:
            algorithm = {
              name: 'NODE-ED25519',
              namedCurve: 'NODE-ED25519'
            };
            keyUsages = ['sign', 'verify'];
            return _context2.abrupt("break", 28);

          case 27:
            throw new JOSENotSupported('Invalid or unsupported crv option provided');

          case 28:
            return _context2.abrupt("break", 50);

          case 29:
            keyUsages = ['sign', 'verify'];
            crv = (_a = options === null || options === void 0 ? void 0 : options.crv) !== null && _a !== void 0 ? _a : 'Ed25519';
            _context2.t2 = crv;
            _context2.next = _context2.t2 === 'Ed25519' ? 34 : _context2.t2 === 'Ed448' ? 34 : 36;
            break;

          case 34:
            algorithm = {
              name: crv
            };
            return _context2.abrupt("break", 37);

          case 36:
            throw new JOSENotSupported('Invalid or unsupported crv option provided');

          case 37:
            return _context2.abrupt("break", 50);

          case 38:
            keyUsages = ['deriveKey', 'deriveBits'];
            _crv = (_b = options === null || options === void 0 ? void 0 : options.crv) !== null && _b !== void 0 ? _b : 'P-256';
            _context2.t3 = _crv;
            _context2.next = _context2.t3 === 'P-256' ? 43 : _context2.t3 === 'P-384' ? 43 : _context2.t3 === 'P-521' ? 43 : _context2.t3 === 'X25519' ? 45 : _context2.t3 === 'X448' ? 45 : 47;
            break;

          case 43:
            algorithm = {
              name: 'ECDH',
              namedCurve: _crv
            };
            return _context2.abrupt("break", 48);

          case 45:
            algorithm = {
              name: _crv
            };
            return _context2.abrupt("break", 48);

          case 47:
            throw new JOSENotSupported('Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448');

          case 48:
            return _context2.abrupt("break", 50);

          case 49:
            throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');

          case 50:
            return _context2.abrupt("return", crypto.subtle.generateKey(algorithm, (_c = options === null || options === void 0 ? void 0 : options.extractable) !== null && _c !== void 0 ? _c : false, keyUsages));

          case 51:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _generateKeyPair.apply(this, arguments);
}